import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { User } from '@account-users/user/models/User';

@Component({
  selector: 'app-user-blocked',
  templateUrl: './user-blocked.component.html',
  styleUrls: ['./user-blocked.component.scss'],
})
export class UserBlockedComponent {
  @Input() user: User;
  @Input() isUnblockingUser = false;
  @Input() canBlock = false;
  @Output() deleteBlockedByLogin = new EventEmitter<User>();
  @Output() blockUser = new EventEmitter<void>();
}
